import { Lock } from 'lucide-react'

/**
 * The editor toolbar's "you cannot write here" indicator.
 *
 * A LOCK, not the word "Read-only". Same yellow as before — the colour is the
 * signal and it carries across the workspace and the share-view — but the toolbar
 * is a strip of icons and a word was the only thing in it made of letters, so it
 * ate width that the actual tools needed on a narrow pane (and on a phone).
 *
 * The DEPTH of the yellow is theme-dependent (`.ws-readonly-badge` in index.css): the
 * bright yellow-400 that works on a near-black surface glows illegibly on the light
 * theme's near-white one, so light gets a deep yellow (yellow-700) — same hue, not
 * amber, which would read as a different signal. Hence a class, not Tailwind colour
 * utilities — the app themes by class, which Tailwind's `dark:` variant can't see.
 *
 * It stays an INDICATOR: it lives in the toolbar's `status` slot, which never
 * collapses into the overflow burger. That is deliberate — a read-only state you
 * have to open a menu to discover is not a state you have been told about.
 *
 * `aria-label` + `data-tooltip` keep the word available to screen readers, to a
 * hover, and to tests, which is why dropping the visible text costs nothing but
 * width. The hint goes through TooltipHost like every other toolbar control —
 * a native `title` beside them hovers on the OS's own timing, which is the
 * inconsistency this family was moved off.
 */
export function ReadOnlyBadge() {
  return (
    <span
      role="img"
      aria-label="Read-only"
      data-tooltip="Read-only — you don't have permission to edit this file"
      className="ws-readonly-badge inline-flex items-center justify-center rounded p-1"
    >
      <Lock size={12} />
    </span>
  )
}
